<template>
  <div
    class="bg-white dark:!bg-surface-primary dark:!border-dark-border p-6 w-fit rounded-lg"
    :class="cardClass"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  cardClass: {
    type: String,
    default: "!border !border-border-default  shadow-2xs !border-[1px]",
  },
});
</script>
